class ComponentCardEvenementDashboard {
  constructor() {
    this._init();
  }

  _init() {
    const copyElements = document.querySelectorAll('.card-evenement-dashboard__code');

    copyElements.forEach((el) => {
      const target = el as HTMLElement;

      target.addEventListener('click', () => {
        this.copyToClipboard(target);
      });
    });
  }

  private async copyToClipboard(el: HTMLElement): Promise<void> {
    const code = el.getAttribute('data-code');

    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      this.showFeedback(el);
    } catch (err) {
      console.log(err);
    }
  }

  private showFeedback(el: HTMLElement): void {
    el.classList.add('is-copied');
    setTimeout(() => {
      el.classList.remove('is-copied');
    }, 2000);
  }
}

export const componentCardEvenementDashboard = new ComponentCardEvenementDashboard();
